module.exports = __webpack_public_path__ + "static/favicon-6104a87f2f9dcf0f2ff9be84f3b8226b.ico";